import { memo, useState, useRef, useEffect } from 'react'
import { Center, ModalFooter, Button, Heading, ModalBody, ModalHeader, Box } from '@chakra-ui/react'

import { useUploadImage } from 'components/uploads/UploadImage/context/Provider'
import { CustomFeedback } from 'components'

function WebcamPreview() {
  const { setView, setNewImage, isOpen } = useUploadImage()
  const [error, setError] = useState('')

  const videoRef = useRef<HTMLVideoElement | null>(null)

  useEffect(() => {
    async function loadAsyncFunction() {
      if ('mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices) {
        try {
          const videoStream = await navigator.mediaDevices.getUserMedia({
            video: true,
          })
          if (videoRef.current) {
            videoRef.current.srcObject = videoStream
            videoRef.current.play()
          }
        } catch (error: any) {
          if (error.message === 'Requested device not found') {
            setError('Parece que seu aparelho não possui um dispositivo de vídeo')
          } else {
            setError('Acesso a câmera negado')
          }
        }
      } else {
        setError('O navegador não permitiu acesso e/ou requisição a câmera')
      }
    }
    loadAsyncFunction()
  }, [])

  const closeCamera = () => {
    const stream = videoRef.current?.srcObject as MediaStream
    if (stream) {
      stream.getTracks().forEach((track) => track.stop())
    }
  }

  if (!isOpen) {
    closeCamera()
  }

  const backToGallery = () => {
    setView('Gallery')
    closeCamera()
  }

  const cropImage = () => {
    if (!videoRef.current) return
    const canvas = document.createElement('canvas')
    canvas.height = videoRef.current.videoHeight
    canvas.width = videoRef.current.videoWidth
    const context = canvas.getContext('2d')
    context?.drawImage(videoRef.current, 0, 0)
    canvas.toBlob(function (blob) {
      if (!blob) return
      const file = new File([blob], 'imagem.png')
      const url = URL.createObjectURL(file)
      setNewImage({ file, url })
      setView('Cropper')
      closeCamera()
    })
  }

  return (
    <>
      <ModalHeader>
        <Heading size="md">Tirar foto</Heading>
      </ModalHeader>

      <ModalBody p={0}>
        {error ? (
          <Center height="500px">
            <CustomFeedback context="withoutCamera" description={error} />
          </Center>
        ) : (
          <Center minHeight="100%" minWidth="{modalBodyRef.current?.clientWidth}" m={0} p={0}>
            <Box as="video" minWidth="100%" id="webcam-video" ref={videoRef} />
          </Center>
        )}
      </ModalBody>

      <ModalFooter>
        <Button variant="outline" onClick={() => backToGallery()}>
          Voltar
        </Button>
        <Button isDisabled={!!error} onClick={cropImage}>
          Tirar foto
        </Button>
      </ModalFooter>
    </>
  )
}

export default memo(WebcamPreview)
